import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import useGetCampaignUpdates from "pages/campaign/hooks/useGetCampaignUpdates";
import useGetCampaignUpdate from "pages/campaign/hooks/useGetCampaignUpdate";
import { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import CampaignUpdates from "./components/CampaignUpdates/CampaignUpdates";
import CampaignUpdatesPreview from "./components/CampaignUpdatesPreview/CampaignUpdatesPreview";
import CampaignUpdateModal from "./components/CampaignUpdateModal/CampaignUpdateModal";
const isNarrow = window.matchMedia("(max-width: 768px)").matches;
const QUERY_FIRST = isNarrow ? 6 : 12;
const stripUpdateFromUrl = () => {
    const basePath = window.location.pathname
        .replace(/\/updates\/[^/]+$/, "")
        .replace(/\/$/, "");
    window.history.replaceState(null, "", basePath || "/");
};
const CampaignUpdatesWrapper = ({ campaign, isPreview = false, isCommentsEnabled, onViewAllUpdates, openUpdateId, }) => {
    const { updates, loadMore, hasNextPage, loading, error, } = useGetCampaignUpdates({
        campaignId: campaign.id,
        limit: QUERY_FIRST,
    });
    // Deep-linked update: fetch it directly so the modal opens regardless of which
    // page of the feed it lives on (it may not be in the loaded list at all).
    const deepLinkId = isPreview ? null : openUpdateId;
    const { update: deepLinkUpdate } = useGetCampaignUpdate({ id: deepLinkId });
    const [deepLinkOpen, setDeepLinkOpen] = useState(true);
    const handleDeepLinkClose = () => {
        setDeepLinkOpen(false);
        stripUpdateFromUrl();
    };
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorFallback, { error: error }), children: _jsxs("div", { className: "campaign-container__updates-wrapper", children: [isPreview ? (_jsx(CampaignUpdatesPreview, { updates: updates, campaign: campaign, loading: loading, onViewAllUpdates: onViewAllUpdates, isCommentsEnabled: isCommentsEnabled })) : (_jsx(CampaignUpdates, { updates: isPreview ? updates.slice(0, 3) : updates, campaign: campaign, fetchMore: loadMore, loading: loading, hasNextPage: isPreview ? false : hasNextPage, isCommentsEnabled: isCommentsEnabled })), deepLinkOpen && deepLinkUpdate && (_jsx(CampaignUpdateModal, { update: deepLinkUpdate, campaign: campaign, onClose: handleDeepLinkClose, isCommentsEnabled: isCommentsEnabled }))] }) }));
};
export default CampaignUpdatesWrapper;
